"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamInGameSchema = void 0;
const ETeam_1 = require("./ETeam");
const zod_1 = require("zod");
const ETurn_1 = require("./ETurn");
const EDiceEvent_1 = require("./EDiceEvent");
const SlotDTO_1 = require("./SlotDTO");
const SavingsDTO_1 = require("./SavingsDTO");
const PleasurePointsDTO_1 = require("./PleasurePointsDTO");
const ProjectDTO_1 = require("./ProjectDTO");
const CardDTO_1 = require("./CardDTO");
const ChargeDTO_1 = require("./ChargeDTO");
const IncomeDTO_1 = require("./IncomeDTO");
const ECardHandler_1 = require("./ECardHandler");
const ECardStateGame_1 = require("./ECardStateGame");
const MoneyDTO_1 = require("./MoneyDTO");
const DiceEventDTO_1 = require("./DiceEventDTO");
const DicesTurnDTO_1 = require("./DicesTurnDTO");
const CardChoiceDTO_1 = require("./CardChoiceDTO");
const PlayerDTO_1 = require("./PlayerDTO");
const TeamInGameSchema = zod_1.z.object({
    teamColor: zod_1.z.nativeEnum(ETeam_1.ETeam),
    turnState: zod_1.z.nativeEnum(ETurn_1.ETurn),
    charges: zod_1.z.array(ChargeDTO_1.ChargeSchema),
    incomes: zod_1.z.array(IncomeDTO_1.IncomeSchema),
    slotTeam: SlotDTO_1.SlotSchema,
    diceEventState: zod_1.z.nativeEnum(EDiceEvent_1.EDiceEvent),
    savings: SavingsDTO_1.SavingsSchema,
    money: MoneyDTO_1.MoneySchema,
    pleasurPoints: PleasurePointsDTO_1.PleasurePointsSchema,
    project: ProjectDTO_1.ProjectDTOSchema,
    cardHandlerEnum: zod_1.z.nativeEnum(ECardHandler_1.ECardHandler),
    cardState: zod_1.z.nativeEnum(ECardStateGame_1.ECardStateGame),
    cards: zod_1.z.array(CardDTO_1.CardSchema),
    dicesTurn: DicesTurnDTO_1.DicesTurnSchema,
    dicesEvent: DiceEventDTO_1.DiceEventSchema,
    cardSelected: CardChoiceDTO_1.CardChoiceSchema,
    cardProposed: zod_1.z.array(CardChoiceDTO_1.CardChoiceSchema),
    shouldApplyEndOfMonthEffect: zod_1.z.boolean(),
    turnNumber: zod_1.z.number(),
    monthNumber: zod_1.z.number(),
    players: zod_1.z.array(PlayerDTO_1.PlayerDTOSchema),
});
exports.TeamInGameSchema = TeamInGameSchema;
